import { Check, Languages } from 'lucide-react';
import { LOCALES, LOCALE_LABELS, type Locale } from '@kts/shared';
import { Dropdown } from './Menu';

/**
 * Til tanlagichi. Ikki ko'rinishda:
 *  - `chips` — login sahifasi va mobil ilovalar uchun (tugmachalar qatori);
 *  - `menu`  — topbar va profil menyusi uchun (ochiluvchi ro'yxat).
 *
 * Har til O'Z tilida yoziladi — foydalanuvchi o'zinikini taniy olishi uchun.
 */
export interface LanguageSwitcherProps {
  locale: Locale;
  onChange: (locale: Locale) => void;
  variant?: 'chips' | 'menu';
  className?: string;
  /** Menyu ko'rinishida tugmada to'liq nom ko'rsatilsinmi. */
  withLabel?: boolean;
}

export function LanguageSwitcher({ locale, onChange, variant = 'menu', className, withLabel }: LanguageSwitcherProps) {
  if (variant === 'chips') {
    return (
      <div className={className} style={{ display: 'inline-flex', gap: 6, flexWrap: 'wrap' }}>
        {LOCALES.map((l) => (
          <button
            key={l}
            type="button"
            className="kts-chip"
            aria-pressed={l === locale}
            lang={l}
            onClick={() => onChange(l)}
          >
            {LOCALE_LABELS[l].native}
          </button>
        ))}
      </div>
    );
  }

  return (
    <Dropdown
      align="right"
      width={200}
      trigger={({ toggle }) => (
        <button
          type="button"
          className={withLabel ? 'kts-chip' : 'kts-icon-btn'}
          onClick={toggle}
          aria-label={LOCALE_LABELS[locale].native}
          title={LOCALE_LABELS[locale].native}
        >
          <Languages size={withLabel ? 15 : 17} />
          {withLabel && <span>{LOCALE_LABELS[locale].short}</span>}
        </button>
      )}
      items={LOCALES.map((l) => ({
        key: l,
        label: <span lang={l}>{LOCALE_LABELS[l].native}</span>,
        icon: l === locale ? <Check /> : <span style={{ width: 16 }} />,
        active: l === locale,
        onSelect: () => onChange(l),
      }))}
    />
  );
}
